import { z } from "zod";

/**
 * Calendar Event ID
 *
 * Must be a stable, non-empty identifier for calendar UI events.
 * This is NOT a phone number and must NOT be constrained to E.164.
 */
export const CalendarEventIdSchema = z.string().min(1).brand("CalendarEventId");

export type CalendarEventId = z.infer<typeof CalendarEventIdSchema>;

export function createCalendarEventId(value: string): CalendarEventId {
	return CalendarEventIdSchema.parse(value);
}

export function isCalendarEventId(value: unknown): value is CalendarEventId {
	return CalendarEventIdSchema.safeParse(value).success;
}
